import { render, staticRenderFns } from "./EditAdminForm.vue?vue&type=template&id=3adca8aa&scoped=true&"
import script from "./EditAdminForm.vue?vue&type=script&lang=js&"
export * from "./EditAdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adca8aa",
  null
  
)

export default component.exports